import request, {casRequest} from "@/plugins/axios";
import store from "@/store/index"

let insertUser = ["admin", "appAdmin", "user"]

export function login(username, password) {
  let data = new URLSearchParams()
  if (!insertUser.includes(username) && (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === "test")) {
    data.append("mobile", username)
    data.append("password", password)
    data.append("service", "FS_ANONYMOUS_8797230805210335931")
    return casRequest.post("/login/rest", data)
  } else {
    data.append("username", username)
    data.append("password", password)
    return request.post("/login", data)
  }
}

export function logout() {
  let username = store.state.user.username
  if (!insertUser.includes(username) && (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === "test")) {
    let data = new URLSearchParams()
    data.append("service", "FS_ANONYMOUS_8797230805210335931")
    return casRequest.get("/logout", data)
  } else {
    return request.get("/logout")
  }
}

export async function findUserAccount() {
  try {
    return await request.get("/public/account")
  } catch (error) {
    return false
  }
}
